@if (!fetching()) {
  <app-product-info [disabled]="saving()">
    <ng-template #card>
      <!-- @if (chart()) { -->
      <app-product-dimension-inputs [disabled]="saving()" />
      <!-- } -->
    </ng-template>

    <ng-template #main>
      <app-chart-container page="product" [disabled]="saving()" />
    </ng-template>

    <ng-template #top>
      <div class="mr-5">
        <app-grading [disabled]="saving()" />
      </div>
    </ng-template>
  </app-product-info>
}

<div class="card mt-10 flex gap-6 p-5">
  <button mat-button (click)="back.emit()">
    {{ 'common.back' | translate }}
  </button>

  <button mat-flat-button (click)="onContinue()" [disabled]="saving()">
    {{ (saving() ? 'common.creating...' : 'common.continue') | translate }}
  </button>
</div>
